import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmComponent } from '../components/dialog-confirm/dialog-confirm/dialog-confirm.component';

@Injectable({
  providedIn: 'root'
})
export class DialogConfirmServiceService {

  constructor(private confirmDialog : MatDialog ) { }

  public openConfirmDialog(msg : string) {
  return  this.confirmDialog.open(DialogConfirmComponent, {
      width:'500px',
      panelClass: 'confirm-dialog-container',
      disableClose: true,
      data: {
        message: msg
      }
    })
  }
}
